export default __webpack_public_path__ + "static/media/studenttracker.63b06e1b.png";